export default "__VITE_ASSET__CAQf2Oy5__"